module.exports = __webpack_public_path__ + "img/icon_sm_ycllysq.80fb71cd.png";